import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getWorkPerformanceResultStart,
  getWorkPerformanceResultSuccess,
  getWorkPerformanceResultFailed,
} from "../redux/getWorkPerformanceResult";

import { getWorkPerformanceResultApi } from "core/http/service/personnelInformation";

function* getWorkPerformanceResult() {
  try {
    const res = yield call(getWorkPerformanceResultApi);

    yield put({
      type: getWorkPerformanceResultSuccess.type,
      payload: res,
    });
  } catch (error: any) {
    yield put({
      type: getWorkPerformanceResultFailed.type,
    });
  }
}

function* watchGetWorkPerformanceResult() {
  yield takeLatest(
    getWorkPerformanceResultStart.type,
    getWorkPerformanceResult
  );
}

export default function* getWorkPerformanceResultSaga() {
  yield all([watchGetWorkPerformanceResult()]);
}
